import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseService } from '../shared/base.service';

@Injectable({
    providedIn: 'root'
})

export class PostalService extends BaseService {

   public getCountries(idToken: string) {
        const headers = this.getHeaders(idToken);
        return this.httpClient.get(`${this.backendDomain}/countries`, { headers });
    }
}